import { getIdToken } from "../auth/CognitoClient";
import { env } from "../env";

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

const join = (p: string) =>
  env.apiUrl.endsWith("/") || p.startsWith("/") ? `${env.apiUrl.replace(/\/$/, "")}${p}` : `${env.apiUrl}/${p}`;

interface RequestOptions {
  method?: "GET" | "POST" | "PUT" | "DELETE";
  body?: unknown;
  raw?: boolean;
}

export async function api<T = unknown>(path: string, opts: RequestOptions = {}): Promise<T> {
  const token = await getIdToken();
  if (!token) throw new ApiError(401, "not signed in");
  const res = await fetch(join(path), {
    method: opts.method ?? "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      ...(opts.body ? { "Content-Type": "application/json" } : {}),
    },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  if (res.status === 204) return undefined as T;
  if (!res.ok) {
    let msg = `${res.status}`;
    try {
      const err = await res.json();
      msg = err.error ?? msg;
    } catch {
      // ignore
    }
    throw new ApiError(res.status, msg);
  }
  if (opts.raw) return res as unknown as T;
  return (await res.json()) as T;
}

export const apiBlob = async (path: string): Promise<Blob> => {
  const token = await getIdToken();
  const res = await fetch(join(path), {
    headers: { Authorization: `Bearer ${token ?? ""}` },
  });
  if (!res.ok) throw new ApiError(res.status, `${res.status}`);
  return res.blob();
};
